import {
  Col,
  Form,
  Input,
  Radio,
  Row,
  Space,
  Table,
  Upload,
  UploadFile,
} from 'antd';
import Button from 'components/Button';
import { DownloadIcon } from 'assets/svg';
import { MainLayout } from 'components';
import useQueryParam from 'hooks/useQueryPrams';
import { useEffect, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import pageTitleStore from 'store/pageTitleStore';
import { Content } from 'antd/es/layout/layout';
import { ColumnsType } from 'antd/es/table';
import { HocChangePagination } from 'utils/HocChangePagination';
import * as XLSX from 'xlsx';
import { openNotificationWithIcon } from 'utils/notification';
import { UploadProps } from 'antd/lib';
import AllocateApi from 'apis/Allocate';
import { useUser } from 'contexts/User';
import CabinetApi from 'apis/CabinetApi';
import { DEFAULT_PAGE_SIZE } from 'utils/constants';
import { data_tu } from 'mock/data';
import { useMutation } from 'react-query';
import CapitalApi from 'apis/CapitalApi';
import PopupConfirmBase from 'components/PopupConfirmBase';
import formatNumber from 'utils/formatNumber';

export default function PlantDeclareCreateCabinet() {
  interface Iparam {
    id: string;
  }
  const { id } = useParams<Iparam>();
  const { detailCapitalShop } = useLocation().state as any;
  const cap_shop_id = parseInt(id);
  const history = useHistory();
  const { user } = useUser();
  const queryParam = useQueryParam();
  const [selectedFile, setSelectedFile] = useState<UploadFile>();
  const [tudonghangs, setTuDongHangs] = useState<any[]>([]);
  const [isUpdateLoading, setUpdateLoading] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const page = parseInt(queryParam.get('page') + '') || 1;
  const page_size =
    parseInt(queryParam.get('page_size') + '') || DEFAULT_PAGE_SIZE;
  const functionParams = {
    page: page,
    page_size: page_size,
  };

  const params = JSON.parse(JSON.stringify(functionParams));

  const setTitle = pageTitleStore((state) => state.setTitle);
  const setBreadcrumb = pageTitleStore((state) => state.setBreadcrumb);
  useEffect(() => {
    setTitle('Tạo khai báo tủ kinh doanh');
    setBreadcrumb([
      {
        title: (
          <p>
            <a href="/plants-allocate">Chi nhánh</a>
          </p>
        ),
      },
      {
        title: (
          <p>
            <a href="/plants-allocate">Vốn tồn chi nhánh</a>
          </p>
        ),
      },
      {
        title: (
          <p>
            <a href="/plants-allocate">Phân bổ vốn tồn</a>
          </p>
        ),
      },
      {
        title: <a href="">Tạo khai báo tủ kinh doanh</a>,
      },
    ]);
  }, []);

  const columns: ColumnsType<any> = [
    {
      title: 'STT',
      dataIndex: 'id',
      width: 80,
      render: (text, record, index) => index + 1 + page_size * (page - 1),
    },
    {
      title: 'Mã tủ',
      dataIndex: 'cabinet_code',
      width: 100,
    },
    {
      title: 'Tủ Xman trưng bày',
      dataIndex: 'cabinet_name',
      width: 180,
    },
    {
      title: 'Số lượng tủ kỳ này',
      dataIndex: 'total_cabinet',
      width: 180,
    },
    // {
    //   title: 'Số lượng dây TBM',
    //   width: 180,
    //   dataIndex: 'sample_display_quantity',
    // },
    {
      title: 'Min kế hoạch',
      dataIndex: 'min_register',
      width: 160,
    },
    {
      title: 'Max kế hoạch',
      dataIndex: 'max_register',
      width: 160,
    },
    {
      title: 'Tỷ trọng vốn Max kế hoạch (%)',
      dataIndex: 'ratio_max',
      width: 200,
    },
    {
      title: 'Vốn max kế hoạch',
      dataIndex: 'von_max',
      width: 200,
      render(value, record, index) {
        const data = detailCapitalShop?.capital_ratio_pof.filter(
          (item: any) => item.pof_type_code === 'suggest'
        );
        console.log(data);
        const max = (data || [])[0]?.amount_max || 0;
        return formatNumber(Math.round((max * record.ratio_max) / 100));
      },
    },
    {
      width: 0.1,
      fixed: 'right',
    },
  ];

  function generateExcel() {
    const data = [];
    // create title
    const headerRow = columns
      .filter((column) => column.dataIndex != 'von_max')
      .map((column) => {
        return column.title;
      });
    data.push(headerRow);
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    const dataSheet2: any = [];

    const columnsHeader = [
      'MA_KV',
      'MO_HINH_KINH_DOANH',
      'Mã tủ',
      'Tủ Xman trưng bày',
      'DVTB',
      'SUC_CHUA_TOI_THIEU_DVTB',
      'SUC_CHUA_TOI_DA_DVTB',
    ];
    const headerRowSheet2 = columnsHeader.map((column) => {
      return column;
    });
    dataSheet2.push(headerRowSheet2);

    data_tu.forEach((prm: any) => {
      const rowData: any = columnsHeader.map((column) => {
        return prm[column];
      });
      dataSheet2.push(rowData);
    });

    const wsSheet2 = XLSX.utils.aoa_to_sheet(dataSheet2);
    XLSX.utils.book_append_sheet(wb, wsSheet2, 'Tham khảo');

    XLSX.writeFile(wb, `tu_dong_hang.xlsx`);
  }

  function downloadCabinet() {
    setIsDownloading(true);
    CabinetApi.getCabinet({
      page: 1,
      page_size: 1000,
    })
      .then((response) => {
        setIsDownloading(false);
        const data = [];
        const headerRow = columns.map((column) => {
          return column.title;
        });
        data.push(headerRow);
        response.data.forEach((prm) => {
          const rowData = columns.map((column) => {
            return prm[column.dataIndex];
          });
          data.push(rowData);
        });

        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.aoa_to_sheet(data);
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        XLSX.writeFile(wb, `tu_hang.xlsx`);
      })
      .catch((error: any) => {
        setIsDownloading(false);
        openNotificationWithIcon(
          'error',
          'Bạn không có quyền tải danh sách tủ'
        );
      });
  }

  function checkEmptyValue(value: any, indexRow: number, index: number) {
    if (value == '' || value == undefined) {
      openNotificationWithIcon(
        'error',
        `Dòng ${indexRow + 1}: ${columns[index].title} đang trống`
      );
      return true;
    }
    return false;
  }

  function checkNumberValue(value: any, indexRow: number, index: number) {
    if (isNaN(Number(value))) {
      openNotificationWithIcon(
        'error',
        `Dòng ${indexRow + 2}: ${columns[index].title} phải là số`
      );
      return true;
    }
    return false;
  }

  function hasDuplicateElements(nestedArray: Array<any>) {
    const filteredArray = nestedArray.filter(
      (subArray) => subArray && subArray.length > 0
    );
    const fifthElements: any[] = filteredArray.map((subArray) => subArray[1]);
    const uniqueSet: Set<any> = new Set(fifthElements);
    return uniqueSet.size !== fifthElements.length;
  }

  function isDecimalWithOneDigit(
    number: number,
    indexRow: number,
    index: number,
    name: string
  ) {
    const numberString = number.toString();
    console.log(numberString);
    const parts = numberString.split('.');
    if ((parts.length === 2 && parts[1].length === 1) || parts.length == 1) {
      return true;
    }
    openNotificationWithIcon(
      'error',
      `${name}: ${columns[index].title} phần thập phân bắt buộc có một chữ số`
    );
    return false;
  }

  function isInteger(
    number: number,
    indexRow: number,
    index: number,
    name: string
  ) {
    const numberString = number.toString();
    console.log(numberString);
    if (Number.isInteger(Number(numberString))) {
      return true;
    }
    openNotificationWithIcon(
      'error',
      `${name}: ${columns[index].title} phải là số nguyên`
    );
    return false;
  }

  function handleUploadFile(info: UploadProps) {
    try {
      if (info.fileList) {
        const files = info.fileList.map((file: any) => {
          return file.originFileObj;
        });
        if (files.length != 0) {
          const file = info.fileList[0];
          setSelectedFile(file);
          const reader = new FileReader();

          reader.onload = (e) => {
            if (e.target) {
              const data = e.target.result;
              const workbook = XLSX.read(data, { type: 'array' });
              const firstSheetName = workbook.SheetNames[0];
              const worksheet = workbook.Sheets[firstSheetName];

              let excelData = XLSX.utils.sheet_to_json<any[]>(worksheet, {
                header: 1,
                range: 0,
              });

              if (
                excelData.length == 0 ||
                excelData[0].length == 0 ||
                excelData[0][0] != 'STT'
              ) {
                openNotificationWithIcon(
                  'error',
                  'File không đúng mẫu, vui lòng tải mẫu'
                );
                return;
              }
              if (excelData.length == 1) {
                openNotificationWithIcon('error', 'File không có dữ liệu');
                return;
              }
              excelData = excelData.slice(1);

              const isDuplicate = hasDuplicateElements(excelData);

              if (isDuplicate) {
                openNotificationWithIcon(
                  'error',
                  'Mã tủ bị trùng lặp! Không thể import!'
                );
                setSelectedFile(undefined);
                return;
              }

              const newTuDongHangs: any[] = [];

              for (let indexRow = 0; indexRow < excelData.length; indexRow++) {
                const row = excelData[indexRow];
                // excelData.forEach((row, indexRow) => {
                const product: any = {};
                if (row.length != 0) {
                  for (let index = 0; index < columns.length; index++) {
                    const value = row[index]?.toString().trim();
                    switch (columns[index].dataIndex) {
                      case 'cabinet_code':
                        if (checkEmptyValue(value, indexRow, index)) return;
                        product[columns[index].dataIndex] = value;
                        break;
                      case 'total_cabinet':
                        if (
                          checkEmptyValue(value, indexRow, index) ||
                          checkNumberValue(value, indexRow, index) ||
                          !isDecimalWithOneDigit(
                            Number(value),
                            indexRow,
                            index,
                            product.cabinet_name
                          )
                        )
                          return;
                        product[columns[index].dataIndex] = Number(value);
                        break;
                      case 'min_register':
                        if (
                          checkEmptyValue(value, indexRow, index) ||
                          checkNumberValue(value, indexRow, index) ||
                          !isInteger(
                            Number(value),
                            indexRow,
                            index,
                            product.cabinet_name
                          )
                        )
                          return;
                        product[columns[index].dataIndex] = Number(value);
                        break;
                      case 'max_register':
                        if (
                          checkEmptyValue(value, indexRow, index) ||
                          checkNumberValue(value, indexRow, index) ||
                          !isInteger(
                            Number(value),
                            indexRow,
                            index,
                            product.cabinet_name
                          )
                        )
                          return;
                        product[columns[index].dataIndex] = Number(value);
                        break;
                      case 'ratio_max':
                        if (
                          checkEmptyValue(value, indexRow, index) ||
                          checkNumberValue(value, indexRow, index) ||
                          !isDecimalWithOneDigit(
                            Number(value),
                            indexRow,
                            index,
                            product.cabinet_name
                          )
                        )
                          return;
                        product[columns[index].dataIndex] = Number(value);
                        break;
                      // case 'von_max':
                      //   product[columns[index].dataIndex] = product['ratio_max'] *
                      default:
                        product[columns[index].dataIndex] = value;
                        break;
                    }
                  }
                  if (
                    product.min_register < 0 ||
                    product.max_register < 0 ||
                    product.total_cabinet < 0
                  ) {
                    openNotificationWithIcon(
                      'error',
                      `${product.cabinet_name}: ${
                        product.total_cabinet < 0
                          ? 'Số lượng tủ'
                          : product.min_register < 0
                          ? 'Min kế hoạch'
                          : 'Max kế hoạch'
                      } < 0`
                    );
                    return;
                  } else if (product.min_register > product.max_register) {
                    openNotificationWithIcon(
                      'error',
                      `${product.cabinet_name}: Min kế hoạch > Max kế hoạch`
                    );
                    return;
                  } else if (
                    product.total_cabinet == 0 ||
                    product.total_cabinet == undefined ||
                    product.total_cabinet == null
                  ) {
                    openNotificationWithIcon(
                      'error',
                      `${product.cabinet_name}: số lượng tủ không được ${
                        product.total_cabinet == 0 ? 'bằng 0' : 'bỏ trống'
                      }.`
                    );
                    return;
                  } else if (
                    product.ratio_max == undefined ||
                    product.ratio_max == null
                  ) {
                    openNotificationWithIcon(
                      'error',
                      `${product.cabinet_name}: tỷ trọng vốn Max không được bỏ trống.`
                    );
                    return;
                  } else if (product.ratio_max < 0 || product.ratio_max > 100) {
                    openNotificationWithIcon(
                      'error',
                      `${product.cabinet_name}: tỷ trọng vốn Max không được ${
                        product.total_cabinet < 0 ? 'âm' : 'lớn hơn 100'
                      }.`
                    );
                  } else {
                    newTuDongHangs.push(product);
                  }
                }
              }

              let total_ratio_max = newTuDongHangs.reduce(
                (sum, item) => sum + item.ratio_max,
                0
              );
              total_ratio_max = Math.round(total_ratio_max * 100) / 100;

              if (total_ratio_max != 100) {
                openNotificationWithIcon(
                  'error',
                  `Tổng tỷ trọng vốn Max phải bằng 100.`
                );
                return;
              }

              setTuDongHangs(newTuDongHangs);
            }
          };
          const blob = file.originFileObj as Blob;
          reader.readAsArrayBuffer(blob);
        }
      }
    } catch (err) {
      openNotificationWithIcon('error', 'File không đúng định dạng mẫu');
    }
  }

  const list_cabinet_code = tudonghangs.map((item) => item.cabinet_code);

  const { mutate: checkTuXmanDiff } = useMutation(
    () =>
      CapitalApi.checkTuXmanDiff({
        id_capital_shop: cap_shop_id,
        list_cabinet_code: list_cabinet_code,
      }),
    {
      onSuccess: (data) => {
        if (data?.data && data?.data.length > 0) {
          setIsModalOpen(true);
        } else {
          handleUpdate();
        }
      },
      onError: (error) => {
        console.log('er: ', error);
      },
    }
  );

  const handleUpdate = () => {
    setUpdateLoading(true);
    const params = {
      data: tudonghangs,
      cap_shop_id: cap_shop_id,
      plant_code: user?.plantCode,
    };
    AllocateApi.importCabinets(params)
      .then((response) => {
        setUpdateLoading(false);
        if (response.success == 'success') {
          openNotificationWithIcon(
            'success',
            'Phân bổ thành công, vui lòng gửi phê duyệt để đặt hàng'
          );
          setIsModalOpen(false);
          history.push('/plants-allocate');
        } else {
          openNotificationWithIcon('error', response.message);
        }
      })
      .catch((err: any) => {
        setUpdateLoading(false);
        openNotificationWithIcon(
          'error',
          err.response?.data?.message.toString()
        );
      });
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setTuDongHangs([]);
  };

  return (
    <MainLayout isLoading={isUpdateLoading || isDownloading}>
      <Content>
        <Row
          gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
          justify="end"
          className="mb-1"
        >
          <Col span={12}>
            <h6>Tủ, dòng hàng</h6>
          </Col>
          <Col span={12} className="flex justify-end">
            <Space>
              <Button
                bgColor={'bg-white'}
                color={'text-primary-50'}
                border="border-primary-50"
                onClick={generateExcel}
              >
                Tải mẫu tại đây
                <DownloadIcon />
              </Button>
              {/* <Button
                bgColor={'bg-white'}
                color={'text-primary-50'}
                border="border-primary-50"
                onClick={downloadCabinet}
              >
                Tải danh sách tủ
                <DownloadIcon />
              </Button> */}
            </Space>
          </Col>
        </Row>

        <Form layout="vertical">
          <Row align="middle" gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="" span={21}>
              <Form.Item label="Danh sách phân bổ">
                <Input
                  disabled={true}
                  placeholder="Tải file định dạng .xls, .csv"
                  className=""
                  value={selectedFile?.name}
                />
              </Form.Item>
            </Col>
            <Col span={3}>
              {/* <Button
                bgColor={'bg-white'}
                color={'text-primary-50'}
                border="border-primary-50"
              >
                Browser
              </Button> */}
              <Upload
                accept=".xlsx,.xls,.csv"
                onChange={handleUploadFile}
                beforeUpload={() => false}
                fileList={[]}
                showUploadList={false}
              >
                <Button
                  bgColor={'bg-white'}
                  color={'text-primary-50'}
                  border={'border-primary-50'}
                  customClass="fix-border-radius"
                >
                  Browser
                </Button>
              </Upload>
            </Col>
          </Row>
        </Form>

        <div className="mt-4">
          <Table
            rowKey={(record) => record.id}
            columns={columns}
            scroll={{ x: 858 }}
            className="customTable"
            dataSource={tudonghangs}
            // loading={''}
            pagination={{
              current: page,
              pageSize: page_size,
              total: tudonghangs.length,
              showSizeChanger: true,
              pageSizeOptions: ['10', '20', '50'],
              onChange: HocChangePagination(history),
            }}
          />
        </div>

        <div className="mt-20 pt-4 border-t-2 border-neutral-90">
          <Form>
            <Row
              gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
              justify="end"
              className="mb-1"
            >
              <Col span={12} className="flex justify-end">
                <Space>
                  <Button
                    bgColor={'bg-white'}
                    color={'text-primary-50'}
                    border="border-primary-50"
                    onClick={() => {
                      history.push('/plants-allocate');
                    }}
                  >
                    Trở lại
                  </Button>
                  <Button onClick={checkTuXmanDiff}>Lưu phân bổ</Button>
                </Space>
              </Col>
            </Row>
          </Form>
        </div>
      </Content>
      <PopupConfirmBase
        isVisible={isModalOpen}
        title={'Thông báo'}
        description={
          'Bạn đã khai báo thiếu tủ so với lần khai báo trước. Việc đồng ý tiếp tục khai báo sẽ xóa hết dữ liệu khai báo của tủ cũ!'
        }
        onOk={() => {
          handleUpdate();
        }}
        onCancel={closeModal}
      ></PopupConfirmBase>
    </MainLayout>
  );
}
